import { render, staticRenderFns } from "./Inventari.vue?vue&type=template&id=10b65a96&"
import script from "./Inventari.vue?vue&type=script&lang=js&"
export * from "./Inventari.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports